export default (content) => {
    if (content?.content?.[0]?.items?.length) {
        return content.content[0].items.reduce((acc, val) => {
            if (val && Object.prototype.hasOwnProperty.call(val, 'tags') && val.tags) {
                val.tags
                    .find((tag) => tag.name === 'product-measurements')
                    .children.forEach((tag) => {
                        acc[tag.text] = val;
                    });
            }
            return acc;
        }, {});
    }
    return {};
};
